import * as React from 'react';
import { InvoiceRow } from './InvoiceRow';
import { InvoiceCard } from './InvoiceCard';
import type { Invoice } from '@/types/payment';

interface InvoicesListProps {
  invoices: Invoice[];
  onDownload: (invoice: Invoice) => void;
}

export const InvoicesList: React.FC<InvoicesListProps> = ({ invoices, onDownload }) => {
  const headerClass =
    'font-sans font-bold text-16 leading-21 text-gray-500 uppercase tracking-normal pb-4 px-4 text-left align-bottom';

  return (
    <div className='w-full'>
      {/* Desktop Table (>= md) */}
      <div className='hidden overflow-x-auto md:block'>
        <table className='w-full min-w-[900px] table-fixed border-collapse'>
          <colgroup>
            <col className='w-[12%]' />
            <col className='w-[14%]' />
            <col className='w-[16%]' />
            <col className='w-[24%]' />
            <col className='w-[16%]' />
            <col className='w-[18%]' />
          </colgroup>

          <thead>
            <tr>
              <th className={`${headerClass} border-b-3 border-gray-480 pl-0`}>Status</th>
              <th className={`${headerClass} border-b-3 border-gray-480`}>Date</th>
              <th className={`${headerClass} border-b-3 border-gray-480`}>Invoice</th>
              <th className={`${headerClass} border-b-3 border-gray-480`}>Description</th>
              <th className={`${headerClass} border-b-3 border-gray-480`}>Amount</th>
              <th className={`${headerClass} border-b-3 border-gray-480 pr-0 text-right`}>
                Download
              </th>
            </tr>
          </thead>

          <tbody>
            {invoices.map((invoice) => (
              <InvoiceRow key={invoice.id} invoice={invoice} onDownload={onDownload} />
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards (< md) */}
      <div className='flex flex-col gap-4 md:hidden'>
        {invoices.map((invoice) => (
          <InvoiceCard key={invoice.id} invoice={invoice} onDownload={onDownload} />
        ))}
      </div>
    </div>
  );
};
